module.exports = "/packs/010-5dcb5055222ac73c5bb3fe308e57cd9e.jpg";